<template>
  <section>
    <v-container fluid>
      <v-col cols="12" class="pt-0 mb-3">
        <v-row justify="space-between" align="center">
          <v-col cols="auto" class="d-none d-lg-block">
            <div class="font-weight-bold"> {{ $global.FilterPermissions('06-020').sub_title | capitalize }}</div>
          </v-col>
          <GenericInput type="date" :keydownEnter="getData" paddingX="px-1" backgroundColor="white" prefix="from date"
            dense :value="from_date" :maxDate="to_date || today" @input="from_date = $event" label="" :required="false"
            :hide-details="true" :isLoading="pageData.isLoading" :cols="[6, 3, 2]">
          </GenericInput>
          <GenericInput type="date" :keydownEnter="getData" paddingX="px-1" backgroundColor="white" prefix="from date"
            dense :value="to_date" :minDate="from_date" :maxDate="today" @input="to_date = $event" label=""
            :required="false" :hide-details="true" :isLoading="pageData.isLoading" :cols="[6, 3, 2]">
          </GenericInput>
          <GenericInput type="select" :clearable="true" :lookups="branches" :value="branch_id" paddingX="px-1"
            backgroundColor="white" dense @input="branch_id = $event" label="branch" :multi="false" :required="false"
            selected_label="name" selected_prop="id" :hide-details="true" :isLoading="(pageData.isLoading)"
            :cols="[6, 3, 2]">
          </GenericInput>
          <GenericInput type="select" :clearable="true" :lookups="users" :value="user_id" @input="user_id = $event"
            paddingX="px-1" backgroundColor="white" dense label="employee" :multi="false" :required="false"
            selected_label="user_full_name" selected_prop="id" :hide-details="true" :isLoading="(pageData.isLoading)"
            :cols="[6, 3, 2]">
          </GenericInput>

          <v-col cols="auto" class="px-1 d-flex">
            <v-btn depressed :loading="pageData.isLoading" @click="getSearch(pageData.search)" :height="37" :width="100"
              color="success" class="rounded-lg mx-1">
              {{ $t("search") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-row align="center" justify="center">
        <v-col cols="12" class="py-0">
          <v-card class="elevation-0 pa-0 rounded-md" color="transparent">
            <DynamicTable :tableHeight="$store.state.Settings.windowSize.y - 200" :viewTitle="false"
              :isLoading="pageData.isLoading" :data="pageData.rows" :header="pageData.tableHeader"
              :option="pageData.options" tableTitle="requests list" :pageData="pageData">
              <template v-slot:td="{ row, header }">
                <div v-if="header.key == 'actions'">
                  <v-btn @click="showShift(row)" x-small icon fab>
                    <v-icon>mdi-eye-outline</v-icon>
                  </v-btn>
                </div>
              </template>
            </DynamicTable>
          </v-card>
        </v-col>

        <v-col cols="12" sm="12" v-if="!pageData.isLoading && pageData.rows.length > 0">
          <Pagination :pagination="pageData.pagination" :limit="pageData.rowsNumber" :backValueMethod="changePage"
            :isLoading="pageData.isLoading"></Pagination>
        </v-col>

      </v-row>

    </v-container>
  </section>
</template>

<script>

import DynamicTable from '@/components/DynamicTable.vue';
import GenericInput from '@/components/GenericInput.vue';
import Pagination from '@/components/Pagination.vue';

export default {
  name: "ExpensesEntity",
  computed: {

  },
  components: {
    DynamicTable,
    GenericInput,
    Pagination
  },

  data: () => ({
    pageData: {
      screen_code: "06-020",
      url: '/list_shifts',
      controlRoute: null,
      entityName: null,
      main: null,
      category: null,
      isLoading: true,
      isTrashed: 1,
      rowsNumber: 15,
      tableHeader: [],
      search: "",
      rows: [],
      options: {},
      page: 1,
      pagination: {},
      controlDialog: false,
      controlID: null,
      queryParam: '?'
    },
    // lockups :
    branches: [],
    branch_id: null,

    payment_types: [],
    payment_type_id: null,

    cart_types: [],
    cart_type_id: null,

    users: [],
    user_id: null,

    today: null,
    from_date: null,
    to_date: null,
  }),
  watch: {
    $route() {
      this.pageData.queryParam = '?';
      this.queryParams();
      this.pageMainData();
      this.getData();
    },
    '$store.state.Settings.key_clicked'() {
      switch (this.$store.state.Settings.key_clicked) {
        case 'F5':
          this.getData();
          break;
        default:
          break;
      }
    },
  },
  mounted() {
    if (this.$global.CheckAction(this.pageData.screen_code, 1)) {
      this.queryParams();
      this.pageMainData();
      this.today = this.$global.GetCurrentDate();
      this.from_date = this.$global.GetFirstDayOfMonth();
      this.to_date = this.$global.GetCurrentDate();
      this.getData();
    } else {
      this.$router.push("/");
      this.$global.ShowAlert('info', this.$i18n.t('no permission'), false, this.$i18n.t('check permission with admin'))
    }
  },
  methods: {
    queryParams() {
      this.pageData.isTrashed = Number(this.$store.state.activeScreen.queryParams.active);
      this.pageData.page = Number(this.$store.state.activeScreen.queryParams.page) || 1;
      this.pageData.rowsNumber = Number(this.$store.state.activeScreen.queryParams.rows) || 10;
      this.pageData.search = this.$store.state.activeScreen.queryParams.word || '';
      this.pageData.queryParam = this.$store.state.activeScreen.requestParam || '';
    },
    pageMainData() {
      this.pageData.tableHeader = [
        { text: "#", key: "id", type: 'text', classes: "", },
        { text: "employee", key: "user_full_name", type: 'text', classes: "", },
        { text: "start date", key: "start_date", type: 'date', classes: "", },
        { text: "end date", key: "end_date", type: 'text', classes: "", },
        { text: "branch", key: "branch_name", type: 'text', classes: "", },
        { text: "start cash", key: "start_cash", type: 'float', classes: "", },
        { text: "sales cash", key: "total_sales_cash", type: 'float', classes: "", },
        { text: "credit notice", key: "total_nc", type: 'float', classes: "", },
        { text: "debit notice", key: "total_nd", type: 'float', classes: "", },
        { text: "expenses", key: "total_expenses", type: 'float', classes: "", },
        { text: "total cash", key: "total_cash", type: 'float', classes: "", },
        { text: "end cash", key: "end_cash", type: 'float', classes: "", },
        { text: "difference", key: "total_diff", type: 'float', classes: "error--text font-weight-bold", },
        { text: "actions", key: "actions", type: 'slot', classes: "", },
      ];
      this.pageData.options = {
        print: this.$global.CheckAction(this.pageData.screen_code, 5),
        delete: this.$global.CheckAction(this.pageData.screen_code, 4),
        edit: this.$global.CheckAction(this.pageData.screen_code, 3),
        restore: this.$global.CheckAction(this.pageData.screen_code, 4),
        view: this.$global.CheckAction(this.pageData.screen_code, 1),
        switch: false,
        selectRow: false,
        sortBy: "id",
        tableHeader: false,
        searchInput: false,
        printButton: false,
        handleClickRow: false,
      };
    },
    getSearch(word) {
      this.pageData.queryParam = `?active=${this.pageData.isTrashed}&rows=${this.pageData.rowsNumber}&page=${this.pageData.page}&word=${word || ''}&user_id=${this.user_id || ''}&branch_id=${this.branch_id || ''}&from_date=${this.from_date || ''}&to_date=${this.to_date || ''}`
      this.$router.push(this.pageData.url + (this.pageData.queryParam || ''))
    },
    getData() {
      this.pageData.isLoading = true;
      this.$api
        .GET_METHOD(`shift${this.pageData.queryParam}&user_id=${this.user_id || ''}&branch_id=${this.branch_id || ''}&from_date=${this.from_date || ''}&to_date=${this.to_date || ''}`)
        .then((response) => {
          this.pageData.isLoading = false;
          if (response.check) {
            this.pageData.entityName =
              this.pageData.isTrashed == 0
                ? this.$i18n.t("deleted from") + " " + this.$store.state.activeScreen.sub_title
                : this.$store.state.activeScreen.sub_title;
                this.users = response.data.users;
              this.branches = response.data.branchs;
              this.pageData.rows = response.data.items.data;
              this.pageData.page = response.data.items.current_page;
              this.pageData.pagination = {
                page: response.data.items.current_page,
                totalPages: response.data.items.last_page,
                per_page: response.data.items.per_page,
                totalRows: response.data.items.total,
              };

          }
        });
    },
    showShift(row) {
      this.$router.push(`/list_shifts/` + row.id);
    },
    changePage(page, limit) {
      this.pageData.queryParam = `?active=${this.pageData.isTrashed}&rows=${limit}&page=${page}&word=${this.pageData.search || ''}&user_id=${this.user_id || ''}&branch_id=${this.branch_id || ''}&from_date=${this.from_date || ''}&to_date=${this.to_date || ''}`
      this.$router.push(this.pageData.url + (this.pageData.queryParam || ''))
    },
    print(row) {
      const src = `${this.$api.serverUrl}list_shifts/${row.id}?type=print&clientID=${this.$store.state.clientID}`;
      this.$api.PrintInvoiceURL(src, row.id)
    },
  },

};
</script>
